import { Else, If, Then, When } from 'react-if';
import { showTimeLong } from '@realwork/crux-utils/date';
import { formatReviewerInitials } from 'rwl-shared/dist/utils/reviews';
import { Body1, ReviewRating, Subtitle2 } from 'rwl-ui';
import styled from 'styled-components6';
import { useReview } from '../../../fetchers/ReviewFetcher/ReviewFetcher';

const AuthorAvatarNoImg = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--rwl-palette-blue-500);
    color: var(--rwl-text-alternative);
    margin-top: var(--rwl-spacing-sm);
`;

const AuthorAvatarImg = styled.img`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    margin-top: var(--rwl-spacing-sm);
`;

const ReviewOverviewContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: var(--rwl-spacing-md);
`;

const ReviewAvatarContainer = styled.div`
    display: flex;
    img {
        margin: var(--rwl-spacing-sm) 0 0 0;
    }
`;

const RatingContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: var(--rwl-spacing-sm);
`;

export const ReviewOverview = () => {
    const { review } = useReview();
    const initials = formatReviewerInitials(review?.author || '?');
    return (
        <When condition={!!review}>
            <ReviewOverviewContainer>
                <ReviewAvatarContainer>
                    <If condition={review?.authorPhotoUrl}>
                        <Then>
                            <AuthorAvatarImg
                                loading="lazy"
                                src={review?.authorPhotoUrl}
                            />
                        </Then>
                        <Else>
                            <AuthorAvatarNoImg>
                                {initials?.toUpperCase() || '?'}
                            </AuthorAvatarNoImg>
                        </Else>
                    </If>
                </ReviewAvatarContainer>
                <div>
                    {review?.author && (
                        <Subtitle2 style={{ fontWeight: '600' }}>
                            {review?.author}
                        </Subtitle2>
                    )}
                    <RatingContainer>
                        <ReviewRating
                            rating={review?.rating || 0}
                            size={'large'}
                            source={review?.source}
                        />
                        {(review?.postedAt || review?.updatedAt) && (
                            <Body1>
                                {showTimeLong(
                                    new Date(
                                        review?.updatedAt || review?.postedAt
                                    ),
                                    'MMM d, yyyy'
                                )}
                            </Body1>
                        )}
                    </RatingContainer>
                </div>
            </ReviewOverviewContainer>
            <Body1>{review?.message}</Body1>
        </When>
    );
};
